import Axios from 'axios';
import { toastr } from 'react-redux-toastr';
import { createAction } from 'redux-act';
import {url} from 'utils/url';
import { log } from 'utils';
import { errorMsg } from 'utils';
import fileDownload from 'js-file-download';
import moment from 'moment';

export const POIS_FETCH_DATA_INIT = createAction('POIS_FETCH_DATA_INIT');
export const POIS_FETCH_DATA_SUCCESS = createAction('POIS_FETCH_DATA_SUCCESS');
export const POIS_FETCH_DATA_FAIL = createAction('POIS_FETCH_DATA_FAIL');

export const POIS_DELETE_POI_INIT = createAction('POIS_DELETE_POI_INIT');
export const POIS_DELETE_POI_SUCCESS = createAction('POIS_DELETE_POI_SUCCESS');
export const POIS_DELETE_POI_FAIL = createAction('POIS_DELETE_POI_FAIL');

export const POIS_CLEAR_DATA = createAction('POIS_CLEAR_DATA');

export const POIS_CREATE_POI_INIT = createAction('POIS_CREATE_POI_INIT');
export const POIS_CREATE_POI_SUCCESS = createAction('POIS_CREATE_POI_SUCCESS');
export const POIS_CREATE_POI_FAIL = createAction('POIS_CREATE_POI_FAIL');

export const POIS_MODIFY_POI_INIT = createAction('POIS_MODIFY_POI_INIT');
export const POIS_MODIFY_POI_SUCCESS = createAction('POIS_MODIFY_POI_SUCCESS');
export const POIS_MODIFY_POI_FAIL = createAction('POIS_MODIFY_POI_FAIL');

export const POIS_CLEAN_UP = createAction('POIS_CLEAN_UP');

export const POIS_CLEAR_DATA_LOGOUT = createAction('POIS_CLEAR_DATA_LOGOUT');
export const POIS_EXPORT_POI_INIT = createAction('POIS_EXPORT_POI_INIT');
export const POIS_EXPORT_POI_SUCCESS = createAction('POIS_EXPORT_POI_SUCCESS');
export const POIS_EXPORT_POI_FAIL = createAction('POIS_EXPORT_POI_FAIL');

export const fetchPois = ({ poiId, siteId }) => {
  // eslint-disable-next-line
  return async (dispatch, getState) => {
    dispatch(POIS_FETCH_DATA_INIT());
    if (poiId) {
      let poiData;
      try {
        poiData = await Axios.get(`${url}/poi/list`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
          params: {
            siteId,
          },
        });
      } catch (error) {
        toastr.error('', `${errorMsg(dispatch, error)}`);
        return dispatch(POIS_FETCH_DATA_FAIL({ error }));
      }
      const poiFind = poiData.data.data.find((x) => x._id === poiId);
      const poi = { ...poiFind, id: poiId };
      return dispatch(
        POIS_FETCH_DATA_SUCCESS({
          list: getState().pois.list,
          poi,
        })
      );
    }

    if (siteId) {
      let pois;
      try {
        pois = await Axios.get(`${url}/poi/list`, {
          params: {
            siteId,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        });
        log(pois.data.data, '<<<< DATA');
      } catch (error) {
        let errorMessage;
        if (error.response) {
          errorMessage = error && error.response && error.response.data.message;
        }
        toastr.error('', errorMessage);
        return dispatch(POIS_FETCH_DATA_FAIL({ error }));
      }
      pois = pois.data.data.filter((poi) => poi.siteId === siteId);
      return dispatch(
        POIS_FETCH_DATA_SUCCESS({
          list: pois,
          poi: getState().pois.poi,
        })
      );
    }
  };
};

export const deletePoi = (id, siteId) => {
  return async (dispatch, getState) => {
    dispatch(POIS_DELETE_POI_INIT());
    try {
      await Axios.post(
        `${url}/poi/delete`,
        {
          poiId: id,
          siteId,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        }
      );
    } catch (error) {
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);
      return dispatch(
        POIS_DELETE_POI_FAIL({
          error: error && error.response && error.response.data,
        })
      );
    }

    toastr.success('', 'The poi was deleted.');
    return dispatch(POIS_DELETE_POI_SUCCESS({ id }));
  };
};

export const clearPoisData = () => {
  return (dispatch) => {
    dispatch(POIS_CLEAR_DATA());
  };
};

export const clearPoisDataLogout = () => {
  return (dispatch) => {
    dispatch(POIS_CLEAR_DATA_LOGOUT());
  };
};

export const createPoi = ({
  uid,
  name,
  phone,
  priority,
  description,
  file,
  opentime,
  url: poiUrl,
  categoryId,
  categoryName,
  floorId,
  floorName,
  siteId,
  tag,
  location,
  floor,
  modifiedAt,
  modifiedBy,
}) => {
  return async (dispatch, getState) => {
    dispatch(POIS_CREATE_POI_INIT());

    // let createPoi;

    let poi = new FormData();
    poi.set('path', 'poi');
    poi.set('name', name);
    poi.set('phone', phone);
    poi.set('priority', priority);
    poi.set('description', description);
    poi.set('opentime', opentime);
    poi.set('url', poiUrl);
    if (categoryId && categoryName) {
      poi.set('categoryId', categoryId);
      poi.set('categoryName', categoryName);
    }
    if (floorId && floorName) {
      poi.set('floorId', floorId);
      poi.set('floorName', floorName);
    }
    poi.set('siteId', siteId);
    poi.set('tag', tag);
    poi.set('location', location);
    poi.set('floor', floor);
    poi.append('file', file);

    try {
      await Axios.post(`${url}/poi/create`, poi, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          'content-type': 'multipart/form-data',
        },
      });
    } catch (error) {
      // let errorMessage;
      // if (error.response) {
      //   errorMessage = error && error.response && error.response.data.message;
      // }

      toastr.error('', 'Please fill in all required fields');
      // toastr.error('', errorMessage);
      return dispatch(
        POIS_CREATE_POI_FAIL({
          error: error && error.response && error.response.data,
        })
      );
    }
    const poiJson = JSON.stringify(Object.fromEntries(poi));
    toastr.success('', 'Poi created successfully');
    return dispatch(POIS_CREATE_POI_SUCCESS({ poi: poiJson }));
  };
};

export const modifyPoi = ({
  id,
  name,
  phone,
  priority,
  description,
  file,
  logo,
  opentime,
  url: poiUrl,
  categoryId,
  categoryName,
  floorId,
  floorName,
  siteId,
  tag,
  location,
  floor,
  modifiedAt,
  modifiedBy,
}) => {
  return async (dispatch, getState) => {
    dispatch(POIS_MODIFY_POI_INIT());

    let poi = new FormData();
    poi.set('path', 'poi');
    poi.set('id', id);
    poi.set('name', name);
    poi.set('phone', phone);
    poi.set('priority', priority);
    poi.set('description', description);
    poi.set('opentime', opentime);
    poi.set('url', poiUrl);
    if (categoryId && categoryName) {
      poi.set('categoryId', categoryId);
      poi.set('categoryName', categoryName);
    }
    if (floorId && floorName) {
      poi.set('floorId', floorId);
      poi.set('floorName', floorName);
    }
    poi.set('siteId', siteId);
    poi.set('tag', tag);
    poi.set('location', location);
    poi.set('floor', floor);
    if (logo) {
      poi.set('logo', logo);
    }
    poi.append('file', file);

    try {
      await Axios.put(`${url}/poi/edit`, poi, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          'content-type': 'multipart/form-data',
        },
      });
    } catch (error) {
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);
      return dispatch(
        POIS_MODIFY_POI_FAIL({
          error: error && error.response && error.response.data,
        })
      );
    }
    const poiJson = JSON.stringify(Object.fromEntries(poi));
    toastr.success('', 'Poi updated successfully');
    return dispatch(POIS_MODIFY_POI_SUCCESS({ poiJson, id }));
  };
};

export const downloadPois = ({ siteId, siteName }) => {
  return async (dispatch, getState) => {
    dispatch(POIS_EXPORT_POI_INIT());
    Axios.get(`${url}/poi/export`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
      responseType: 'blob',
      params: {
        siteId,
      },
    })
      .then((res) => {
        fileDownload(
          res.data,
          `poi_export_${siteName}_${moment(new Date()).format(
            'YYYY-MM-DD'
          )}.csv`
        );
        return dispatch(POIS_EXPORT_POI_SUCCESS());
      })
      .catch((error) => {
        toastr.error('', `${errorMsg(dispatch, error)}`);
        return dispatch(POIS_EXPORT_POI_FAIL({ error }));
      });
  };
};

export const poisCleanUp = () => (dispatch) => dispatch(POIS_CLEAN_UP());
